import { render } from "./PermisT.vue?vue&type=template&id=77bc928a&scoped=true"
import script from "./PermisT.vue?vue&type=script&lang=js"
export * from "./PermisT.vue?vue&type=script&lang=js"

import "./PermisT.vue?vue&type=style&index=0&id=77bc928a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bc928a"]])

export default __exports__